import request from "../utils/request"

export function assetsCreate (data) {
	return request({
		url: '/assets/create',
		method: 'POST',
		data
	})
}

export function assetsDelete (data) {
	return request({
		url: '/assets/delete',
		method: 'POST',
		data
	})
}


export function assetsUpdate (data) {
	return request({
		url: '/assets/update',
		method: 'POST',
		data
	})
}

export function assetsMyList (params) {
	return request({
		url: '/assets/myList',
		method: 'get',
		params
	})
}

export function getAssetsList (params) {
	return request({
		url: '/assets/index',
		method: 'get',
		params
	})
}

export function getAssets (params) {
	return request({
		url: '/assets/detail',
		method: 'get',
		params
	})
}

export function contactAssets(data) {
	return request({
		url: '/assets/contact',
		method: 'post',
		data
	})
}

export function myAssets(params) {
	return request({
	     url: '/assets/myAssets',
	     method: 'get',
	     params
	})
}